import React from 'react';
import sAction from 'sAction';
import assembleURLHash from '../../action/Base/route/assembleURLHash';

export default function NameCallback(props) {
    const value = sAction.decodeHTMLEntities(props.value);
    const showEyeIcon = true;

    const lineRender = (
        <div className="hrefEffect" onClick={() => props.callback()}>
            <a className="strong" title={value}>
                {value}
            </a>
        </div>
    );

    return (
        <div className={'newListViewLine ' + props.extraClass}>
            {showEyeIcon && (
                <a
                    href={assembleURLHash('detail', props.module, props.id)}
                    target="_blank"
                    className="icon-newTab listViewEyeIcon" rel="noreferrer"
                />
            )}
            {lineRender}
        </div>
    );
}
